import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import ViewImageAndText from '../../components/ViewImageAndText';
import { CModal } from '@coreui/react';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceTeacher } from '../../hooks/useAuthorizedRequestForTeacher';
import { generateAxiosInstanceSectionFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { upload } from '@testing-library/user-event/dist/upload';
import { useNavigate } from 'react-router-dom';
import { sectionUploadCompetitiveExamFormValidation } from '../../validation/Validation';
import { ErrorMessage } from '../../validation/validationError';
import { ZodError, preprocess } from 'zod';
import { Loader, QuestionFilter } from '../../components/ModalsCommonFunctions';

const UploadExam = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommon = generateAxiosInstanceCommon()
    const authorizedAxiosSectionFileUpload = generateAxiosInstanceSectionFileUpload()
    const [loading, setLoading] = useState(false);
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const [questionArray, setQuestionArray] = useState([])
    const [questionArrayIndex, setQuestionArrayIndex] = useState([])
    const [viewSelectedQuestion, setViewSelectedQuestion] = useState(false);
    const [tempQuestionArray, setTempQuestionArray] = useState([]);
    const inputRef = useRef(null);

    const initialExamPatterState = {
        teacher_id: "0",
        exam_name: "",
        description: "",
        syllabus_structure_id: '',
        syllabus_structure_type: '',
        class_id: '',
        subject_id: '',
        lesson_id: '0',
        topic_id: '0',
        subtopic_id: '0',
        section_id: sectionMasterId
    }

    const [lessonList, setLessonList] = useState([])
    const [refresh, setRefresh] = useState(true)
    const [examCreateData, setExamCreateData] = useState(initialExamPatterState)
    const [modalData, setModalData] = useState("")
    const [questionList, setQuestionList] = useState([])
    const [visibleSolution, setVisibleSolution] = useState(false);
    const [tempVisibleImage, setTempVisibleImage] = useState(false);
    const [tempModalImageSrc, setTempModalImageSrc] = useState('');
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    //  question
    const initialFilterState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        syllabus_structure_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
        subject_id: '',
        file: null
    }

    const [filter, setFilter] = useState(initialFilterState);
    const [syllabusList, setSyllabusList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [classList, setClassList] = useState([])
    const [filterbook, setFilterBook] = useState()
    const [topicList, setTopicList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [syType, setSyType] = useState()
    const [examType, setExamType] = useState(true)
    const navigate = useNavigate();

    const initialCompetitiveExamPatterState = {
        exam_name: "",
        description: "",
        class_id: '',
        competitive_exam_name_id: '',
        competitive_exam_type: '',
        competitive_exam_book_id: '',
        subject_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
        section_id: sectionMasterId,
        is_competitive: 'Y',
        file: null,
    }
    const [questionArrayCompetitiveExam, setQuestionArrayCompetitiveExam] = useState([])
    const [questionArrayIndexCompetitiveExam, setQuestionArrayIndexCompetitiveExam] = useState([])
    const [viewSelectedQuestionCompetitiveExam, setViewSelectedQuestionCompetitiveExam] = useState(false);
    const [tempQuestionArrayCompetitiveExam, setTempQuestionArrayCompetitiveExam] = useState([]);

    const [competitiveExamNameList, setCompetitiveExamNameList] = useState([]);
    const [competitiveExamBookList, setCompetitiveExamBookList] = useState([])
    const [subjectListCompetitiveExam, setSubjectListCompetitiveExam] = useState([])
    const [lessonListCompetitiveExam, setLessonListCompetitiveExam] = useState([])
    const [topicListCompetitiveExam, setTopicListCompetitiveExam] = useState([])
    const [subtopicListCompetitiveExam, setSubtopicListCompetitiveExam] = useState([])
    const [filterbookCompetitiveExam, setFilterBookCompetitiveExam] = useState()
    const [refreshCompetitiveExam, setRefreshCompetitiveExam] = useState(true)
    const [examCreateDataCompetitiveExam, setExamCreateDataCompetitiveExam] = useState(initialCompetitiveExamPatterState)
    const [questionListCompetitiveExam, setQuestionListCompetitiveExam] = useState([])
    const [syTypeCompetitiveExam, setSyTypeCompetitiveExam] = useState()
    const [errorUploadCompetitiveExam, setErrorUploadCompetitiveExam] = useState([])
    const inputRefCompetitiveExam = useRef(null);

    /* Competitive Exam Upload UseState Variables End */
    useEffect(() => {
        const apiUrl = `/delete-temp-uploaded-questions?section_id=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.delete(apiUrl)
            .then(response => {
                handleTempList();
                handleTempListCompetitiveExam();
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.error || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            });
    }, []);

    const tempOnViewImage = (imgSrc) => {
        setTempModalImageSrc(imgSrc);
        setTempVisibleImage(true);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleInputChange = (e) => {
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }

        })
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleClassChange = (e) => {
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                syllabus_structure_id: '',
                syllabus_structure_type: '',
                subject_id: '',
                lesson_id: '0',
                topic_id: '0',
                subtopic_id: '0',
            }
        })

        setFilter((prevData) => {
            return {
                ...prevData,
                syllabus_structure_id: '',
                lesson_id: '',
                topic_id: '',
                subtopic_id: '',
                subject_id: '',
            }
        })

        setSyType();
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubtopicList([]);
        getSyllabusList(e.target.value)
    }

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];
        let fileExtension = file?.name?.substring(file?.name?.lastIndexOf('.') + 1).toLowerCase();
        if (fileExtension === "xlsx") {

            if (file.size/* < 150 * 1024*/) {
                setLoading(true);
                const body = new FormData();
                body.append('file', file)
                const apiUrl = "exams-upload-file";
                authorizedAxiosSectionFileUpload && authorizedAxiosSectionFileUpload.post(apiUrl, body)
                    .then((res) => {
                        setQuestionList(res.data.questions)
                    })
                    .catch((err) => {
                        const errorMsg = err.response.data.error || "Something went wrong!";
                        Swal.fire({
                            text: errorMsg
                        })
                    })
                    .finally(() => {
                        setLoading(false); // End loading
                    });
            }
        } else {
            Swal.fire(
                { text: "only xlsx file supported" }
            );
        }
    }

    const handleInputReset = () => {
        const apiUrl = `/delete-temp-uploaded-questions?section_id=${sectionMasterId}&is_competitive=N`;
        authorizedAxiosSection && authorizedAxiosSection.delete(apiUrl)
            .then(response => {
                handleTempList();
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.error || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            });

        setQuestionArrayIndex([]);
        setSyType();
        setExamCreateData(initialExamPatterState);
        setFilter(initialFilterState);
        setFilterBook();
        setQuestionList([]);
        setSyllabusList([]);
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubtopicList([]);
        inputRef.current.value = '';
        setError(initialErrorState);
    }

    const initialErrorState = {

    };

    const [error, setError] = useState(initialErrorState);

    const validateForm = () => {
        // Check if every error is an empty string
        const excludedKeys = ['teacher_id', 'topic_id', 'subtopic_id', 'section_id'];
        const filteredErrors = Object.keys(error).filter(key => !excludedKeys.includes(key));
        const errorsValid = filteredErrors.every(key => error[key] === '');

        // Check if every value in subtopicData is either a non-empty string or undefined and not equal to "0"
        const examCreateDataValid = Object.entries(examCreateData).every(([key, value]) => {
            // Exclude teacher_id, topic_id, subtopic_id, and section_id from validation
            if (key !== 'teacher_id' && key !== 'topic_id' && key !== 'subtopic_id' && key !== 'section_id') {
                if (typeof value === 'string') {
                    if (value === '') { // Skip validation for empty strings
                        return false;
                    } else if (value === '0') { // Check if value is "0"
                        return false;
                    }
                }
            }
            return true;
        });

        return errorsValid && examCreateDataValid;
    };

    useEffect(() => {
        // Check if any validation errors exist
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(error)) {
                // Exclude certain keys from validation
                if (key !== 'teacher_id' && key !== 'topic_id' && key !== 'subtopic_id' && key !== 'section_id') {
                    // Check if the corresponding value in examCreateData is empty, null, or "0"
                    if (!examCreateData[key] || examCreateData[key] === '' || examCreateData[key] === '0') {
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: 'This field is required.',
                            }
                        });
                    } else {
                        // Clear the error for the field if it's not empty and not "0"
                        setError((prevData) => {
                            return {
                                ...prevData,
                                [key]: '',
                            }
                        });
                    }
                }
            }
        }
    }, [examCreateData]);

    useEffect(() => {
        if (tempQuestionArray?.length == 0) {
            setViewSelectedQuestion(false);
        }
    }, [tempQuestionArray])

    useEffect(() => {
        const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setClassList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            });
    }, [])

    const getSyllabusList = (id) => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure-grade-medium-board-wise?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&instituteGradeMasterId=${id}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';

            });
    }

    const handleSyllabusChange = (e) => {
        setSyType('')
        setLessonList([])
        setTopicList([])
        setSubtopicList([])
        setSubjectList([])
        setFilterBook()
        let id = e.target.value.split('').slice(0, -1).join('');
        let type = e.target.value.split('').pop()
        setSyType(e.target.value.split('').pop())

        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: id,
                syllabus_structure_type: type,
                subject_id: '',
                lesson_id: '0',
                topic_id: '0',
                subtopic_id: '0',
            }
        })

        setFilter((prevData) => {
            return {
                ...prevData,
                lesson_id: '',
                topic_id: '',
                subtopic_id: '',
                subject_id: '',
            }

        })

        if (type == "I") {
            const apiUrl2 = `get-institute-syllabus-structure-Wise-institute-subjects?id=${id}`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
                .then(response => {
                    setSubjectList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (type == "A") {
            const apiUrl2 = `/syllabus-structure-wise-subjects?id=${id}`;
            authorizedAxios && authorizedAxios.get(apiUrl2)
                .then(response => {
                    setSubjectList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (type == "B") {
            const apiUrl2 = `/get-section-syllabus-structure-Wise-section-subjects?id=${id}`;
            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl2)
                .then(response => {
                    setSubjectList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }
    }

    const handleSubjectChange = (e) => {
        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lesson_id: '0',
                topic_id: '0',
                subtopic_id: '0',
            }
        })

        setFilter((prevData) => {
            return {
                ...prevData,
                lesson_id: '',
                topic_id: '',
                subtopic_id: '',
            }
        })

        setTopicList([]);
        setSubtopicList([]);

        if (syType == "B") {
            const apiUrl = `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${e.target.value}`;

            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
                .then(response => {
                    setLessonList(response.data.result)
                    setFilterBook(1)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (syType == "I") {
            const apiUrl = `get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${e.target.value}`;

            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    setLessonList(response.data.result)
                    setFilterBook(1)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (syType == "A") {

            const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${examCreateData.syllabus_structure_id}&subjectMasterId=${e.target.value}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setLessonList(response.data.result)
                    setFilterBook(1)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }
    }

    const handleLessonChange = (e) => {
        setQuestionArray([]);

        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                topic_id: '',
                subtopic_id: '',
            }
        })

        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                topic_id: '0',
                subtopic_id: '0',
            }
        })

        setSubtopicList([]);

        if (syType == "I") {
            const apiUrl = `/get-institute-lesson-wise-institute-sub-topic?id=${e.target.value}`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (syType == "A") {

            const apiUrl = `/lesson-wise-topic?id=${e.target.value}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (syType == "B") {

            const apiUrl = `/get-section-lesson-wise-section-sub-topic?id=${e.target.value}`;
            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }
    }

    const handleTopicChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subtopic_id: '',
            }
        });

        setExamCreateData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subtopic_id: '0',
            }
        });

        if (syType == "I") {
            const apiUrl = `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${examCreateData.subject_id}&instituteLessonMasterId=${filter.lesson_id}&instituteTopicMasterId=${e.target.value}&`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result)
                })
                .catch(error => {
                    setSubtopicList([])
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (syType == "A") {
            const apiUrl = `/get-sub-topic-master-list?syllabusStructureId=${examCreateData.syllabus_structure_id}&subjectMasterId=${examCreateData.subject_id}&lessonId=${filter.lesson_id}&topicId=${e.target.value}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result)
                })
                .catch(error => {
                    setSubtopicList([])
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }

        if (syType == "B") {
            const apiUrl = `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${examCreateData.subject_id}&sectionLessonMasterId=${filter.lesson_id}&sectionTopicMasterId=${e.target.value}`;
            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
                .then(response => {
                    setSubtopicList(response.data.result)
                })
                .catch(error => {
                    setSubtopicList([])
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Error: ", errorMsg);
                });
        }
    }

    const handleQuestionUpdate = (question) => {
        const requiredKeys = ['question', 'option_a', 'option_b', 'option_c', 'option_d', 'ans'];
        const keysWithEmptyValue = requiredKeys.filter(key => !question[key]);

        if (keysWithEmptyValue.length > 0) {
            // Construct alert message with key names having empty values
            const alertMessage = `The following key(s) have empty string or null value: ${keysWithEmptyValue.join(', ')}`;
            Swal.fire({
                text: alertMessage
            });
            return;
        }

        const existingQuestionIndex = questionArray.findIndex(
            (item) => item.q_id === question.q_id
        );

        if (existingQuestionIndex !== -1) {
            const updatedQuestionArray = [...questionArray];
            updatedQuestionArray.splice(existingQuestionIndex, 1);
            setQuestionArray(updatedQuestionArray);
        } else {
            setQuestionArray([
                ...questionArray,
                {
                    section_id: examCreateData.section_id,
                    q_id: question.q_id,
                    lesson_id: filter.lesson_id,
                    topic_id: filter.topic_id,
                    subtopic_id: filter.subtopic_id,
                    class_id: examCreateData.class_id,
                    syllabus_structure_id: examCreateData.syllabus_structure_id,
                    subject_id: examCreateData.subject_id,
                    q_type: question.q_type,
                    q_level: question.q_level,
                    question: question.question,
                    option_a: question.option_a,
                    option_b: question.option_b,
                    option_c: question.option_c,
                    option_d: question.option_d,
                    ans: question.ans,
                    sol: question.sol,
                    syllabus_structure_type: syType
                }
            ]);
        }
    };

    const uploadExam = () => {
        if (validateForm()) {
            const apiUrlForSyllabus = `/exams-upload`;
            setLoading(true);
            authorizedAxiosSection && authorizedAxiosSection.post(apiUrlForSyllabus, examCreateData)
                .then(response => {
                    Swal.fire({ text: response.data.message });
                    handleTempList();
                    setQuestionArrayIndex([]);
                    setSyType();
                    setExamCreateData(initialExamPatterState);
                    setFilter(initialFilterState);
                    setQuestionList([]);
                    setSyllabusList([]);
                    setSubjectList([]);
                    setLessonList([]);
                    setTopicList([]);
                    setSubtopicList([]);
                    inputRef.current.value = '';
                    setError(initialErrorState);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({ text: errorMsg });
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(examCreateData)) {
                if (!value || value === '' || value === '0') {
                    setError(prevData => ({
                        ...prevData,
                        [key]: 'This field is required.',
                    }));
                } else {
                    setError(prevData => ({
                        ...prevData,
                        [key]: '',
                    }));
                }
            }
        }
    }

    const AddExam = () => {
        if (questionArray.length > 0) {
            setLoading(true);
            const apiUrl = `/exams-upload-questions-add-temp`;
            authorizedAxiosSection && authorizedAxiosSection.post(apiUrl, { questions: questionArray })
                .then(response => {
                    setRefresh(!refresh)
                    // setLessonList((prevLessonList) => [...prevLessonList].filter((lesson) => lesson.id !== id))
                    Swal.fire(
                        { text: response.data.message }
                    );
                    setQuestionArrayIndex(response.data.questions.map(i => i.q_id))
                    setFilter(initialFilterState)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            Swal.fire({
                text: "Please Select Atleast One Question"
            })
        }
    }

    const handleTempList = () => {
        const apiUrl = `/exams-upload-questions-temp/${sectionMasterId}`;

        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTempQuestionArray(response.data.questions)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.error || 'Something went wrong!';
                if (errorMsg === "No questions found for the specified section_id") {
                    setTempQuestionArray([]);
                }
            });
    }

    const removeQuestion = (idToRemove) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/exams-upload-questions-temp/${idToRemove}`;
            authorizedAxiosSection && authorizedAxiosSection.delete(apiUrl)
                .then(response => {
                    // setSyllabusList((prevSyllabusList) => [...prevSyllabusList].filter((syllabus) => syllabus.id !== id))
                    // openSuccessSnackbar(response.data.message);
                    setQuestionArrayIndex(prevIds => prevIds.filter(q_id => q_id !== idToRemove))
                    setQuestionArray(prevQuestion => prevQuestion.filter(question => question.q_id !== idToRemove))
                    handleTempList();
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }


    // Competitive Exam Fuctions
    const handleInputChangeCompetitiveExam = (e) => {
        const { name, value } = e.target;
        setExamCreateDataCompetitiveExam((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })

        // Clear the error for the specific field being edited
        if (value.trim() !== '') {
            setErrorUploadCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }
    }

    const handleClassChangeCompetitveExam = (e) => {
        const { name, value } = e.target;
        setExamCreateDataCompetitiveExam((prevData) => {
            return {
                ...prevData,
                [name]: value,
                syllabus_structure_id: '',
                syllabus_structure_type: '',
                subject_id: '',
                lesson_id: '',
                topic_id: '',
                subtopic_id: '',
            }
        })

        if (value.trim() !== '') {
            setErrorUploadCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }

        setSyTypeCompetitiveExam();
        setSubjectListCompetitiveExam([]);
        setLessonListCompetitiveExam([]);
        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);
        getCompetitiveExamNameList(value)
    }

    const getCompetitiveExamNameList = (id) => {
        const apiUrl = `/get-institute-grade-wise-competitive-exam-name?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${id}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl)
            .then(response => {
                setCompetitiveExamNameList(response.data.result)
            })
            .catch(error => {
                setCompetitiveExamNameList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log(errorMsg)
            });
    }

    const handleCompetitiveExamNameChange = (e) => {
        setSubjectListCompetitiveExam([]);
        setLessonListCompetitiveExam([]);
        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);
        let id = e.target.value.split('').slice(0, -1).join('');
        let type = e.target.value.split('').pop()
        setSyTypeCompetitiveExam(type)

        setExamCreateDataCompetitiveExam((prevData) => {
            return {
                ...prevData,
                [e.target.name]: id,
                competitive_exam_type: type,
                competitive_exam_book_id: '',
                subject_id: '',
                lesson_id: '',
                topic_id: '',
                subtopic_id: '',
            }
        })

        if (id.trim() !== '') {
            setErrorUploadCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== e.target.name));
        }

        if (type == "A") {
            const apiUrl2 = `/get-competitive-exam-book-master?competitiveExamNameMasterId=${id}`;
            authorizedAxios && authorizedAxios.get(apiUrl2)
                .then(response => {
                    setCompetitiveExamBookList(response.data.data)
                })
                .catch(error => {
                    setCompetitiveExamBookList([])
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Fetching Error data: ", errorMsg);
                });
        }

        if (type == "I") {
            const apiUrl2 = `/get-institute-competitive-exam-book-master?instituteCompetitiveExamNameMasterId=${id}`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
                .then(response => {
                    setCompetitiveExamBookList(response.data.data)
                })
                .catch(error => {
                    setCompetitiveExamBookList([])
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Fetching Error data: ", errorMsg);
                });
        }
    }

    const handleComepetitiveExamBookChange = (e) => {
        setLessonListCompetitiveExam([]);
        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);

        const { name, value } = e.target;
        setExamCreateDataCompetitiveExam((prevData) => {
            return {
                ...prevData,
                [name]: value,
                subject_id: '',
                lesson_id: '',
                topic_id: '',
                subtopic_id: '',
            }
        })

        // Clear the error for the specific field being edited
        if (value.trim() !== '') {
            setErrorUploadCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }

        if (syTypeCompetitiveExam == "I") {
            const apiUrl2 = `/get-institute-competitive-exam-book-wise-subject?instituteCompetitiveExamBookMasterId=${value}`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
                .then(response => {
                    setSubjectListCompetitiveExam(response.data.result)
                })
                .catch(error => {
                    setSubjectListCompetitiveExam([])
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Fetching Error data: ", errorMsg);
                });
        }

        if (syTypeCompetitiveExam == "A") {
            const apiUrl2 = `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${value}`;
            authorizedAxios && authorizedAxios.get(apiUrl2)
                .then(response => {
                    setSubjectListCompetitiveExam(response.data.result)
                })
                .catch(error => {
                    setSubjectListCompetitiveExam([])
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Fetching Error data: ", errorMsg);
                });
        }
    }

    const handleSubjectChangeCompetitiveExam = (e) => {
        const { name, value } = e.target;
        setExamCreateDataCompetitiveExam((prevData) => {
            return {
                ...prevData,
                [name]: value,
                lesson_id: '',
                topic_id: '',
                subtopic_id: '',
            }
        })

        if (value.trim() !== '') {
            setErrorUploadCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        }

        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);

        if (syTypeCompetitiveExam == "I") {
            const apiUrl = `/get-institute-competitive-lesson-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.competitive_exam_book_id}&instituteSubjectMasterId=${value}`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    setLessonListCompetitiveExam(response.data.result)
                    setFilterBookCompetitiveExam(1)
                })
                .catch(error => {
                    setLessonListCompetitiveExam([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Fetching Error data: ", errorMsg);
                });
        }

        if (syTypeCompetitiveExam == "A") {
            const apiUrl = `/get-competitive-lesson?competitiveExamBookMasterId=${examCreateDataCompetitiveExam.competitive_exam_book_id}&subjectMasterId=${value}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setLessonListCompetitiveExam(response.data.result)
                    setFilterBookCompetitiveExam(1)
                })
                .catch(error => {
                    setLessonListCompetitiveExam([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Fetching Error data: ", errorMsg);
                });
        }
    }

    const handleUploadLogoCompetitiveExam = async (e) => {
        const file = e.target.files[0];
        let fileExtension = file?.name?.substring(file?.name?.lastIndexOf('.') + 1).toLowerCase();
        if (fileExtension === "xlsx") {

            if (file.size/* < 150 * 1024*/) {
                setLoading(true);
                const body = new FormData();
                body.append('file', file)
                const apiUrl = "exams-upload-file";
                authorizedAxiosSectionFileUpload && authorizedAxiosSectionFileUpload.post(apiUrl, body)
                    .then((res) => {
                        setQuestionListCompetitiveExam(res.data.questions)
                        setExamCreateDataCompetitiveExam((prevData) => {
                            return {
                                ...prevData,
                                file: file.name
                            }
                        })

                        if (file.name.trim() !== '') {
                            setErrorUploadCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== e.target.name));
                        }
                    })
                    .catch((err) => {
                        const errorMsg = err.response.data.error || "Something went wrong!";
                        Swal.fire({
                            text: errorMsg
                        })
                    })
                    .finally(() => {
                        setLoading(false); // End loading
                    });
            }
        } else {
            Swal.fire(
                { text: "only xlsx file supported" }
            );
        }
    }

    const handleCompetitiveExamLessonChange = (e) => {
        setSubtopicListCompetitiveExam([]);
        setQuestionArrayCompetitiveExam([]);

        const { name, value } = e.target;
        setExamCreateDataCompetitiveExam((prevData) => {
            return {
                ...prevData,
                [name]: value,
                topic_id: '',
                subtopic_id: '',
            }
        })

        // Clear the error for the specific field being edited
        // if (value.trim() !== '') {
        //   setErrorUploadCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        // }

        if (syTypeCompetitiveExam == "I") {
            const apiUrl = `/get-institute-competitive-topic-master?instituteMasterId${instituteMasterId}&instituteCompetitiveLessonMasterId=${value}`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    setTopicListCompetitiveExam(response.data.result)
                })
                .catch(error => {
                    setTopicListCompetitiveExam([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Fetching Error data: ", errorMsg);
                });
        }

        if (syTypeCompetitiveExam == "A") {
            const apiUrl = `/get-competitive-topic?competitiveLessonMasterId=${value}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setTopicListCompetitiveExam(response.data.result)
                })
                .catch(error => {
                    setTopicListCompetitiveExam([]);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.log("Fetching Error data: ", errorMsg);
                });
        }
    }

    const handleComepetitiveExamTopicChange = (e) => {
        const { name, value } = e.target;
        setExamCreateDataCompetitiveExam((prevData) => {
            return {
                ...prevData,
                [name]: value,
                subtopic_id: '',
            }
        })

        // Clear the error for the specific field being edited
        // if (value.trim() !== '') {
        //   setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
        // }

        if (syTypeCompetitiveExam == "I") {
            const apiUrl = `/get-institute-competitive-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_name_id}&instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&instituteCompetitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&instituteCompetitiveTopicMasterId=${value}`;
            authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
                .then(response => {
                    setSubtopicListCompetitiveExam(response.data.result)
                })
                .catch(error => {
                    setSubtopicListCompetitiveExam([])
                });
        }

        if (syTypeCompetitiveExam == "A") {
            const apiUrl = `/get-competitive-sub-topic?competitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_name_id}&competitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&competitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&competitiveTopicMasterId=${value}`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setSubtopicListCompetitiveExam(response.data.result)
                })
                .catch(error => {
                    setSubtopicListCompetitiveExam([])
                });
        }
    }

    useEffect(() => {
        if (tempQuestionArrayCompetitiveExam?.length == 0) {
            setViewSelectedQuestionCompetitiveExam(false);
        }
    }, [tempQuestionArrayCompetitiveExam])

    const handleTempListCompetitiveExam = () => {
        const apiUrl = `/get-upload-competitive-exam-temp/${sectionMasterId}`;

        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTempQuestionArrayCompetitiveExam(response.data.questions)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.error || 'Something went wrong!';
                if (errorMsg === "No questions found for the specified section_id") {
                    setTempQuestionArrayCompetitiveExam([]);
                }
            });
    }

    const AddQuestionCompetitveExam = () => {
        if (questionArrayCompetitiveExam.length > 0) {
            setLoading(true);
            const apiUrl = `/create-upload-competitive-exam-temp`;
            authorizedAxiosSection && authorizedAxiosSection.post(apiUrl, { questions: questionArrayCompetitiveExam })
                .then(response => {
                    setRefreshCompetitiveExam(!refreshCompetitiveExam)
                    // setLessonList((prevLessonList) => [...prevLessonList].filter((lesson) => lesson.id !== id))
                    Swal.fire(
                        { text: response.data.message }
                    );
                    setQuestionArrayIndexCompetitiveExam(response.data.questions.map(i => i.q_id))
                    setExamCreateDataCompetitiveExam((prevData) => {
                        return {
                            ...prevData,
                            lesson_id: '',
                            topic_id: '',
                            subtopic_id: ''
                        }
                    })
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            Swal.fire({
                text: "Please Select Atleast One Question"
            })
        }
    }

    const removeQuestionCompetitiveExam = (idToRemove) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/exams-upload-questions-temp/${idToRemove}`;
            authorizedAxiosSection && authorizedAxiosSection.delete(apiUrl)
                .then(response => {
                    setQuestionArrayIndexCompetitiveExam(prevIds => prevIds.filter(q_id => q_id !== idToRemove))
                    setQuestionArrayCompetitiveExam(prevQuestion => prevQuestion.filter(question => question.q_id !== idToRemove))
                    handleTempListCompetitiveExam();
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const handleQuestionUpdateCompetitiveExam = (question) => {
        const requiredKeys = ['question', 'option_a', 'option_b', 'option_c', 'option_d', 'ans'];
        const keysWithEmptyValue = requiredKeys.filter(key => !question[key]);

        if (keysWithEmptyValue.length > 0) {
            const alertMessage = `The following key(s) have empty string or null value: ${keysWithEmptyValue.join(', ')}`;
            Swal.fire({
                text: alertMessage
            });
            return;
        }

        const existingQuestionIndex = questionArrayCompetitiveExam.findIndex(
            (item) => item.q_id === question.q_id
        );

        if (existingQuestionIndex !== -1) {
            const updatedQuestionArrayCompetitiveExam = [...questionArrayCompetitiveExam];
            updatedQuestionArrayCompetitiveExam.splice(existingQuestionIndex, 1);
            setQuestionArrayCompetitiveExam(updatedQuestionArrayCompetitiveExam);
        } else {
            setQuestionArrayCompetitiveExam([
                ...questionArrayCompetitiveExam,
                {
                    section_id: examCreateDataCompetitiveExam.section_id,
                    q_id: question.q_id,
                    lesson_id: examCreateDataCompetitiveExam.lesson_id,
                    topic_id: examCreateDataCompetitiveExam.topic_id,
                    subtopic_id: examCreateDataCompetitiveExam.subtopic_id,
                    class_id: examCreateDataCompetitiveExam.class_id,
                    competitive_exam_name_id: examCreateDataCompetitiveExam.competitive_exam_name_id,
                    subject_id: examCreateDataCompetitiveExam.subject_id,
                    q_type: question.q_type,
                    q_level: question.q_level,
                    question: question.question,
                    option_a: question.option_a,
                    option_b: question.option_b,
                    option_c: question.option_c,
                    option_d: question.option_d,
                    ans: question.ans,
                    sol: question.sol,
                    competitive_exam_type: syTypeCompetitiveExam,
                    competitive_exam_book_id: examCreateDataCompetitiveExam.competitive_exam_book_id
                }
            ]);
        }
    };

    // const handleQuestionUpdateCompetitiveExam = (question) => {
    //     const requiredKeys = ['question', 'option_a', 'option_b', 'option_c', 'option_d', 'ans'];

    //     // Function to escape double quotes if not in img src attribute
    //     const escapeDoubleQuotes = (value) => {
    //         if (typeof value !== 'string') return value;

    //         const imgTagRegex = /<img.*?src=".*?".*?>/g;
    //         if (imgTagRegex.test(value)) {
    //             // Ignore escaping if img tag with src and double quotes is found
    //             return value;
    //         }

    //         // Avoid escaping already escaped double quotes
    //         return value.replace(/(?<!\\)"/g, '\\"');
    //     };

    //     // Escape double quotes in question object
    //     requiredKeys.forEach(key => {
    //         if (question[key]) {
    //             question[key] = escapeDoubleQuotes(question[key]);
    //         }
    //     });

    //     const keysWithEmptyValue = requiredKeys.filter(key => !question[key]);

    //     if (keysWithEmptyValue.length > 0) {
    //         const alertMessage = `The following key(s) have empty string or null value: ${keysWithEmptyValue.join(', ')}`;
    //         Swal.fire({
    //             text: alertMessage
    //         });
    //         return;
    //     }

    //     const existingQuestionIndex = questionArrayCompetitiveExam.findIndex(
    //         (item) => item.q_id === question.q_id
    //     );

    //     if (existingQuestionIndex !== -1) {
    //         const updatedQuestionArrayCompetitiveExam = [...questionArrayCompetitiveExam];
    //         updatedQuestionArrayCompetitiveExam.splice(existingQuestionIndex, 1);
    //         setQuestionArrayCompetitiveExam(updatedQuestionArrayCompetitiveExam);
    //     } else {
    //         setQuestionArrayCompetitiveExam([
    //             ...questionArrayCompetitiveExam,
    //             {
    //                 section_id: examCreateDataCompetitiveExam.section_id,
    //                 q_id: question.q_id,
    //                 lesson_id: examCreateDataCompetitiveExam.lesson_id,
    //                 topic_id: examCreateDataCompetitiveExam.topic_id,
    //                 subtopic_id: examCreateDataCompetitiveExam.subtopic_id,
    //                 class_id: examCreateDataCompetitiveExam.class_id,
    //                 competitive_exam_name_id: examCreateDataCompetitiveExam.competitive_exam_name_id,
    //                 subject_id: examCreateDataCompetitiveExam.subject_id,
    //                 q_type: question.q_type,
    //                 q_level: question.q_level,
    //                 question: question.question,
    //                 option_a: question.option_a,
    //                 option_b: question.option_b,
    //                 option_c: question.option_c,
    //                 option_d: question.option_d,
    //                 ans: question.ans,
    //                 sol: question.sol,
    //                 competitive_exam_type: syTypeCompetitiveExam,
    //                 competitive_exam_book_id: examCreateDataCompetitiveExam.competitive_exam_book_id
    //             }
    //         ]);
    //     }
    // };    

    // const uploadCompetitiveExam = async () => {
    //     try {
    //         await sectionUploadCompetitiveExamFormValidation.parseAsync(examCreateDataCompetitiveExam);
    //         setErrorUploadCompetitiveExam([]);

    //         const apiUrlForSyllabus = `/create-upload-competitive-exam`;

    //         authorizedAxiosSection && authorizedAxiosSection.post(apiUrlForSyllabus, examCreateDataCompetitiveExam)
    //             .then(response => {
    //                 Swal.fire({ text: response.data.message });
    //                 handleTempListCompetitiveExam();
    //                 setQuestionArrayIndexCompetitiveExam([]);
    //                 setSyTypeCompetitiveExam();
    //                 setExamCreateDataCompetitiveExam(initialExamPatterState);
    //                 setQuestionListCompetitiveExam([]);
    //                 setCompetitiveExamNameList([]);
    //                 setCompetitiveExamBookList([]);
    //                 setSubjectListCompetitiveExam([]);
    //                 setLessonListCompetitiveExam([]);
    //                 setTopicListCompetitiveExam([]);
    //                 setSubtopicListCompetitiveExam([]);
    //                 inputRefCompetitiveExam.current.value = '';
    //                 // setError(initialErrorState);
    //             })
    //             .catch(error => {
    //                 const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //                 Swal.fire({ text: errorMsg });
    //             });
    //     } catch (error) {
    //         if (error instanceof ZodError) {
    //             setErrorUploadCompetitiveExam(error.errors); // Set validation errors
    //         }
    //     }
    // }

    const uploadCompetitiveExam = async () => {
        try {
            // Validate the form data using Zod
            await sectionUploadCompetitiveExamFormValidation.parseAsync(examCreateDataCompetitiveExam);
            setErrorUploadCompetitiveExam([]); // Clear any previous validation errors

            setLoading(true);

            const apiUrlForSyllabus = `/create-upload-competitive-exam`;

            // Make the API call using async/await
            const response = await authorizedAxiosSection.post(apiUrlForSyllabus, examCreateDataCompetitiveExam);

            // Handle success response
            Swal.fire({ text: response.data.message });
            handleTempListCompetitiveExam();

            // Reset states and form fields
            setQuestionArrayIndexCompetitiveExam([]);
            setSyTypeCompetitiveExam(null);
            setExamCreateDataCompetitiveExam(initialExamPatterState);
            setQuestionListCompetitiveExam([]);
            setCompetitiveExamNameList([]);
            setCompetitiveExamBookList([]);
            setSubjectListCompetitiveExam([]);
            setLessonListCompetitiveExam([]);
            setTopicListCompetitiveExam([]);
            setSubtopicListCompetitiveExam([]);
            if (inputRefCompetitiveExam.current) {
                inputRefCompetitiveExam.current.value = '';
            }

        } catch (error) {
            if (error instanceof ZodError) {
                // Handle validation errors
                setErrorUploadCompetitiveExam(error.errors);
            } else {
                // Handle other errors, including network errors
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire({ text: errorMsg });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleInputResetCompetitiveExam = () => {
        const apiUrl = `/delete-temp-uploaded-questions?section_id=${sectionMasterId}&is_competitive=Y`;
        authorizedAxiosSection && authorizedAxiosSection.delete(apiUrl)
            .then(response => {
                handleTempListCompetitiveExam();
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.error || 'Something went wrong!';
                Swal.fire({
                    text: errorMsg
                })
            });
        setQuestionArrayIndexCompetitiveExam([]);
        setTempQuestionArrayCompetitiveExam([]);
        setQuestionListCompetitiveExam([]);
        setSyTypeCompetitiveExam();
        setExamCreateDataCompetitiveExam(initialExamPatterState);
        setFilterBookCompetitiveExam();
        setQuestionListCompetitiveExam([]);
        setCompetitiveExamNameList([]);
        setCompetitiveExamBookList([])
        setSubjectListCompetitiveExam([]);
        setLessonListCompetitiveExam([]);
        setTopicListCompetitiveExam([]);
        setSubtopicListCompetitiveExam([]);
        inputRefCompetitiveExam.current.value = '';
        setErrorUploadCompetitiveExam([]);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Upload Exam</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i>Upload Exam </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <button className={`${examType ? 'active' : ''} btn btn-light btn-width`} onClick={() => setExamType(true)}>Upload Text Book Exam</button>
                                                </div>
                                                <div className="col-md-6">
                                                    <button className={`${examType ? '' : 'active'} btn btn-light btn-width`} onClick={() => setExamType(false)}>Upload Competitive Exam</button>
                                                </div>
                                            </div>

                                            {examType === true && <div className="row">
                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name </label>
                                                    <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={(e) => handleInputChange(e)} value={examCreateData.exam_name} />
                                                    {error.exam_name && <p style={{ color: 'red' }}>{error.exam_name}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description  </label>
                                                    <input type="text" className="form-control" id={`description`} name='description' onChange={(e) => handleInputChange(e)} value={examCreateData.description} />
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleClassChange} value={examCreateData.class_id}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            classList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.class_id && <p style={{ color: 'red' }}>{error.class_id}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabus_structure_id' onChange={handleSyllabusChange} value={examCreateData.syllabus_structure_id + syType}>
                                                        <option selected value={''} >Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option style={{ color: syllabus.type == "I" ? "blue" : syllabus.type == "B" ? "red" : '' }} value={syllabus.id + syllabus.type}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.syllabus_structure_id && <p style={{ color: 'red' }}>{error.syllabus_structure_id}</p>}
                                                </div>

                                                {syType == "B" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} value={examCreateData?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.subject_id && <p style={{ color: 'red' }}>{error.subject_id}</p>}
                                                    </div>
                                                </>}

                                                {syType == "I" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} value={examCreateData?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.subject_id && <p style={{ color: 'red' }}>{error.subject_id}</p>}
                                                    </div>

                                                </>}

                                                {syType == "A" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} value={examCreateData?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    return <option value={syllabus?.subjectMasterDetails?.id}>{syllabus?.subjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.subject_id && <p style={{ color: 'red' }}>{error.subject_id}</p>}
                                                    </div>
                                                </>}

                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Exam Question :<span style={{ color: "red" }}>only xlsx file supported </span></label>
                                                    <input type="file" className="form-control" id={`file`} name='file' onChange={(e) => handleUploadLogo(e)} value={examCreateData?.file?.name} ref={inputRef} />
                                                    <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample xlsx file</a>

                                                    {error.file && <p style={{ color: 'red' }}>{error.file}</p>}
                                                </div>

                                                {(syType == "A" || syType == "I" || syType == "B") && <>
                                                    <div className="col-md-6 view_content_radio_btn">
                                                        <label>
                                                            <input type="radio" value="1" name="filterbook" checked={filterbook == 1} onClick={() => setFilterBook(1)} /> Lesson
                                                        </label>
                                                        <label>
                                                            <input type="radio" value="2" name="filterbook" checked={filterbook == 2} onClick={() => setFilterBook(2)} /> Topic
                                                        </label>

                                                        <label>
                                                            <input type="radio" value="3" name="filterbook" checked={filterbook == 3} onClick={() => setFilterBook(3)} /> Sub Topic
                                                        </label>
                                                    </div>
                                                </>}

                                                {syType == "B" && <div className="row">
                                                    {(filterbook == 1 || filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleLessonChange} value={filter.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonList?.map((lesson) => {
                                                                    return <option value={lesson.id}>{lesson.sectionLessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.lesson_id && <p style={{ color: 'red' }}>{error.lesson_id}</p>}
                                                    </div>}
                                                    {(filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleTopicChange} value={filter.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicList?.map((topic) => {
                                                                    return <option value={topic.id}>{topic.sectionTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.topic_id && <p style={{ color: 'red' }}>{error.topic_id}</p>}
                                                    </div>}

                                                    {filterbook == 3 && <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={filter.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicList?.map((topic) => {
                                                                    return <option value={topic.id}>{topic.sectionSubTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.subtopic_id && <p style={{ color: 'red' }}>{error.subtopic_id}</p>}
                                                    </div>}
                                                </div>}

                                                {syType == "I" && <div className="row">
                                                    {(filterbook == 1 || filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleLessonChange} value={filter.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonList?.map((lesson) => {
                                                                    return <option value={lesson?.id}>{lesson?.instituteLessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.lesson_id && <p style={{ color: 'red' }}>{error.lesson_id}</p>}
                                                    </div>}
                                                    {(filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleTopicChange} value={filter.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicList?.map((topic) => {
                                                                    return <option value={topic?.id}>{topic?.instituteTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.topic_id && <p style={{ color: 'red' }}>{error.topic_id}</p>}
                                                    </div>}

                                                    {filterbook == 3 && <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={filter.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicList?.map((topic) => {
                                                                    return <option value={topic?.id}>{topic?.instituteSubTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.subtopic_id && <p style={{ color: 'red' }}>{error.subtopic_id}</p>}
                                                    </div>}
                                                </div>}

                                                {syType == "A" && <div className="row">
                                                    {(filterbook == 1 || filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleLessonChange} value={filter.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonList?.map((lesson) => {
                                                                    return <option value={lesson?.id}>{lesson?.lessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.lesson_id && <p style={{ color: 'red' }}>{error.lesson_id}</p>}
                                                    </div>}

                                                    {(filterbook == 2 || filterbook == 3) && <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleTopicChange} value={filter.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicList?.map((topic) => {
                                                                    return <option value={topic?.id}>{topic?.topicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.topic_id && <p style={{ color: 'red' }}>{error.topic_id}</p>}
                                                    </div>}

                                                    {filterbook == 3 && <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={filter.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicList?.map((topic) => {
                                                                    return <option value={topic?.id}>{topic?.subTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {error.subtopic_id && <p style={{ color: 'red' }}>{error.subtopic_id}</p>}
                                                    </div>}

                                                </div>}
                                            </div>}

                                            {examType === false && <div className="row">
                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name </label>
                                                    <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.exam_name} />
                                                    <ErrorMessage errors={errorUploadCompetitiveExam} field="exam_name" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description  </label>
                                                    <input type="text" className="form-control" id={`description`} name='description' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.description} />
                                                    <ErrorMessage errors={errorUploadCompetitiveExam} field="description" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleClassChangeCompetitveExam} value={examCreateDataCompetitiveExam.class_id}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            classList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errorUploadCompetitiveExam} field="class_id" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="competitive_exam_name_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitive_exam_name_id' onChange={handleCompetitiveExamNameChange} value={examCreateDataCompetitiveExam.competitive_exam_name_id + syTypeCompetitiveExam}>
                                                        <option selected value={''} >Select Competitive Exam</option>
                                                        {
                                                            competitiveExamNameList?.map((competitiveExamName) => {
                                                                return <option style={{ color: competitiveExamName.type == "I" ? "blue" : competitiveExamName.type == "B" ? "red" : '' }} value={competitiveExamName.id + competitiveExamName.type}>{competitiveExamName?.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errorUploadCompetitiveExam} field="competitive_exam_name_id" />
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="competitive_exam_book_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitive_exam_book_id' onChange={handleComepetitiveExamBookChange} value={examCreateDataCompetitiveExam.competitive_exam_book_id}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            competitiveExamBookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errorUploadCompetitiveExam} field="competitive_exam_book_id" />
                                                </div>

                                                {/* {syTypeCompetitiveExam == "I" && <div className="col-md-6">
                                                    <label for="competitive_exam_book_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitive_exam_book_id' onChange={handleComepetitiveExamBookChange} value={examCreateDataCompetitiveExam.competitive_exam_book_id}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            competitiveExamBookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    <ErrorMessage errors={errorsCompetitiveExam} field="competitive_exam_book_id" />
                                                </div>} */}

                                                {syTypeCompetitiveExam == "I" && <>
                                                    <div className="col-md-6">
                                                        <label for="subject_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChangeCompetitiveExam} value={examCreateDataCompetitiveExam?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectListCompetitiveExam?.map((syllabus) => {
                                                                    return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errorUploadCompetitiveExam} field="subject_id" />
                                                    </div>
                                                </>
                                                }

                                                {syTypeCompetitiveExam == "A" && <>
                                                    <div className="col-md-6">
                                                        <label for="subject_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChangeCompetitiveExam} value={examCreateDataCompetitiveExam?.subject_id}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectListCompetitiveExam?.map((syllabus) => {
                                                                    return <option value={syllabus?.subjectMasterDetails?.id}>{syllabus?.subjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        <ErrorMessage errors={errorUploadCompetitiveExam} field="subject_id" />
                                                    </div>
                                                </>
                                                }

                                                <div className="col-md-6">
                                                    <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Exam Question :<span style={{ color: "red" }}>only xlsx file supported </span></label>
                                                    <input type="file" className="form-control" id={`file`} name='file' onChange={(e) => handleUploadLogoCompetitiveExam(e)} value={examCreateDataCompetitiveExam?.file?.name} ref={inputRefCompetitiveExam} />
                                                    <a download href='https://api.examninja.co.in/files/question-bank-import-ex.xlsx'>Sample xlsx file</a>
                                                    <ErrorMessage errors={errorUploadCompetitiveExam} field="file" />
                                                </div>

                                                {(syTypeCompetitiveExam == "I" || syTypeCompetitiveExam == "A") && <>
                                                    <div className="col-md-6 view_content_radio_btn">
                                                        <label>
                                                            <input type="radio" value="1" name="filterbook" checked={filterbookCompetitiveExam == 1} onClick={() => setFilterBookCompetitiveExam(1)} /> Lesson
                                                        </label>
                                                        <label>
                                                            <input type="radio" value="2" name="filterbook" checked={filterbookCompetitiveExam == 2} onClick={() => setFilterBookCompetitiveExam(2)} /> Topic
                                                        </label>

                                                        <label>
                                                            <input type="radio" value="3" name="filterbook" checked={filterbookCompetitiveExam == 3} onClick={() => setFilterBookCompetitiveExam(3)} /> Sub Topic
                                                        </label>
                                                    </div>
                                                </>}

                                                {syTypeCompetitiveExam == "I" && <div className="row">
                                                    {(filterbookCompetitiveExam == 1 || filterbookCompetitiveExam == 2 || filterbookCompetitiveExam == 3) && <div className="col-md-6">
                                                        <label for="lesson_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleCompetitiveExamLessonChange} value={examCreateDataCompetitiveExam.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonListCompetitiveExam?.map((lesson) => {
                                                                    return <option value={lesson?.id}>{lesson?.competitiveLessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {/* <ErrorMessage errors={errorUploadCompetitiveExam} field="lesson_id" /> */}
                                                    </div>}
                                                    {(filterbookCompetitiveExam == 2 || filterbookCompetitiveExam == 3) && <div className="col-md-6">
                                                        <label for="topic_id" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleComepetitiveExamTopicChange} value={examCreateDataCompetitiveExam.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicListCompetitiveExam?.map((topic) => {
                                                                    return <option value={topic?.id}>{topic?.competitiveTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {/* <ErrorMessage errors={errorUploadCompetitiveExam} field="topic_id" /> */}
                                                    </div>}

                                                    {filterbookCompetitiveExam == 3 && <div className="col-md-6">
                                                        <label for="subtopic_id" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={filter.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicListCompetitiveExam?.map((topic) => {
                                                                    return <option value={topic?.id}>{topic?.competitiveSubTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {/* <ErrorMessage errors={errorUploadCompetitiveExam} field="subtopic_id" /> */}
                                                    </div>}
                                                </div>}

                                                {syTypeCompetitiveExam == "A" && <div className="row">
                                                    {(filterbookCompetitiveExam == 1 || filterbookCompetitiveExam == 2 || filterbookCompetitiveExam == 3) && <div className="col-md-6">
                                                        <label for="lesson_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleCompetitiveExamLessonChange} value={examCreateDataCompetitiveExam.lesson_id}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonListCompetitiveExam?.map((lesson) => {
                                                                    return <option value={lesson?.id}>{lesson?.competitiveLessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {/* <ErrorMessage errors={errorUploadCompetitiveExam} field="lesson_id" /> */}
                                                    </div>}

                                                    {(filterbookCompetitiveExam == 2 || filterbookCompetitiveExam == 3) && <div className="col-md-6">
                                                        <label for="topic_id" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleComepetitiveExamTopicChange} value={examCreateDataCompetitiveExam.topic_id}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicListCompetitiveExam?.map((topic) => {
                                                                    return <option value={topic?.id}>{topic?.competitiveTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {/* {error.topic_id && <p style={{ color: 'red' }}>{error.topic_id}</p>} */}
                                                    </div>}

                                                    {filterbookCompetitiveExam == 3 && <div className="col-md-6">
                                                        <label for="subtopic_id" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={examCreateDataCompetitiveExam.subtopic_id}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subtopicListCompetitiveExam?.map((topic) => {
                                                                    return <option value={topic?.id}>{topic?.competitiveSubTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                        {/* {error.subtopic_id && <p style={{ color: 'red' }}>{error.subtopic_id}</p>} */}
                                                    </div>}
                                                </div>}
                                            </div>}

                                            {examType === true && <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <div className="col-auto">
                                                    {filter.lesson_id !== '' && questionList.length > 0 && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={AddExam}>Add</button>
                                                    }
                                                    {questionArrayIndex.length != 0 && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={uploadExam}>Save</button>
                                                    }
                                                    <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>

                                                    {questionArrayIndex.length != 0 && <div className={`toggle-container ${viewSelectedQuestion ? 'active' : ''}`} onClick={() => (setViewSelectedQuestion(prevState => !prevState), handleTempList())}>
                                                        <div className="toggle-background"></div>
                                                        <div className="toggle-switch"></div>
                                                    </div>}
                                                </div>
                                            </div>}

                                            {examType === false && <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                <div className="col-auto">
                                                    {examCreateDataCompetitiveExam.lesson_id !== '' && questionListCompetitiveExam.length > 0 && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={AddQuestionCompetitveExam}>Add</button>
                                                    }
                                                    {questionArrayIndexCompetitiveExam.length != 0 && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={uploadCompetitiveExam}>Save</button>
                                                    }
                                                    <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputResetCompetitiveExam}>Reset</button>

                                                    {questionArrayIndexCompetitiveExam.length != 0 && <div className={`toggle-container ${viewSelectedQuestionCompetitiveExam ? 'active' : ''}`} onClick={() => (setViewSelectedQuestionCompetitiveExam(prevState => !prevState), handleTempListCompetitiveExam())}>
                                                        <div className="toggle-background"></div>
                                                        <div className="toggle-switch"></div>
                                                    </div>}
                                                </div>
                                            </div>}
                                        </div>

                                        {tempVisibleImage && (
                                            <CModal
                                                visible={tempVisibleImage}
                                                onClose={() => setTempVisibleImage(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                            >
                                                <div className="book book-modal">
                                                    <div className='table-header-like'>Image</div>
                                                    {tempModalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: tempModalImageSrc }}></div>}
                                                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setTempVisibleImage(false)}>
                                                        Close
                                                    </button>
                                                </div>
                                            </CModal>
                                        )}

                                        {visibleImage && (
                                            <CModal
                                                visible={visibleImage}
                                                onClose={() => setVisibleImage(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                            >
                                                <div className="book book-modal">
                                                    <div className='table-header-like'>Image</div>
                                                    {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                                                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                                                        Close
                                                    </button>
                                                </div>
                                            </CModal>
                                        )}

                                        {examType === true && viewSelectedQuestion &&
                                            <div className="d-grid gap-2 mt-2">
                                                <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                    <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                    <th scope='col'>Lesson</th>
                                                                    <th scope='col'>Topic</th>
                                                                    <th scope='col'>SubTopic</th>
                                                                    <th scope="col">Question</th>
                                                                    <th scope='col'>Solution</th>
                                                                    <th scope='col'>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    tempQuestionArray?.length > 0 ?
                                                                        tempQuestionArray?.map((item, index) => {
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                    <td>{item.lessonName}</td>
                                                                                    <td>{item.topicName}</td>
                                                                                    <td>{item.subTopicName}</td>
                                                                                    <ViewImageAndText inputString={item.question} onViewImage={tempOnViewImage} />
                                                                                    <ViewImageAndText inputString={item.sol} onViewImage={tempOnViewImage} />
                                                                                    <td>
                                                                                        <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => removeQuestion(item.q_id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                        :
                                                                        (<tr>
                                                                            <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                        </tr>)
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {visibleSolution && (
                                            <CModal
                                                visible={visibleSolution}
                                                onClose={() => setVisibleSolution(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                            >
                                                <div className="book book-modal">

                                                    {/* <DecodedHTMLComponent data={modalData} /> */}
                                                    <div className='table-header-like'> Solution</div>

                                                    <div className="page" dangerouslySetInnerHTML={{
                                                        __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>`
                                                    }}></div>

                                                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleSolution(false)}>
                                                        Close
                                                    </button>
                                                </div>
                                            </CModal>
                                        )}

                                        {examType === true && !viewSelectedQuestion && questionList.length > 0 &&
                                            <div className="d-grid gap-2 mt-2">
                                                <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                    <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    {/* <th></th> */}
                                                                    <th scope="col"></th>
                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                    <th scope='col'>Q_Level</th>
                                                                    <th scope='col'>Q_Type</th>
                                                                    <th scope='col'>Question</th>
                                                                    <th scope="col">Option_a</th>
                                                                    <th scope="col">Option_b </th>
                                                                    <th scope="col">Option_c</th>
                                                                    <th scope="col">Option_d</th>
                                                                    <th scope='col'>Answer</th>
                                                                    <th scope='col'>Solution</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    questionList.length !== questionArrayIndex.length && questionList?.length > 0 ?
                                                                        questionList?.map((question, index) => {
                                                                            <QuestionFilter key={index} question={question}></QuestionFilter>
                                                                            return (
                                                                                !questionArrayIndex.includes(question.q_id) && (
                                                                                    <tr key={index}>
                                                                                        <td>
                                                                                            <input
                                                                                                type='checkbox'
                                                                                                disabled={filter.lesson_id === ""}
                                                                                                onChange={() => handleQuestionUpdate(question)}
                                                                                            />
                                                                                        </td>
                                                                                        <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                        <td>{question.q_level}</td>
                                                                                        <td>{question.q_type}</td>
                                                                                        <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                                                                        <td>{question.ans}</td>
                                                                                        <td>
                                                                                            <button
                                                                                                className="btn btn-primary view_icon mt-1"
                                                                                                type="button"
                                                                                                onClick={() => {
                                                                                                    setVisibleSolution(!visibleSolution);
                                                                                                    setModalData(question.sol);
                                                                                                }}
                                                                                            >
                                                                                                <i className="fa fa-eye"></i>
                                                                                            </button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            );
                                                                        })
                                                                        :
                                                                        (<tr>
                                                                            <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                        </tr>)
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {/* Competitive Exam */}
                                        {examType === false && viewSelectedQuestionCompetitiveExam &&
                                            <div className="d-grid gap-2 mt-2">
                                                <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                    <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                    <th scope='col'>Lesson</th>
                                                                    <th scope='col'>Topic</th>
                                                                    <th scope='col'>SubTopic</th>
                                                                    <th scope="col">Question</th>
                                                                    <th scope='col'>Solution</th>
                                                                    <th scope='col'>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    tempQuestionArrayCompetitiveExam?.length > 0 ?
                                                                        tempQuestionArrayCompetitiveExam?.map((item, index) => {
                                                                            return (
                                                                                <tr key={index}>
                                                                                    <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                    <td>{item.lessonName}</td>
                                                                                    <td>{item.topicName}</td>
                                                                                    <td>{item.subTopicName}</td>
                                                                                    <ViewImageAndText inputString={item.question} onViewImage={tempOnViewImage} />
                                                                                    <ViewImageAndText inputString={item.sol} onViewImage={tempOnViewImage} />
                                                                                    <td>
                                                                                        <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => removeQuestionCompetitiveExam(item.q_id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                        :
                                                                        (<tr>
                                                                            <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                        </tr>)
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {examType === false && !viewSelectedQuestionCompetitiveExam && questionListCompetitiveExam.length > 0 &&
                                            <div className="d-grid gap-2 mt-2">
                                                <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                    <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    {/* <th></th> */}
                                                                    <th scope="col"></th>
                                                                    <th scope="col" className='sl_no'>Sr. No.</th>
                                                                    <th scope='col'>Q_Level</th>
                                                                    <th scope='col'>Q_Type</th>
                                                                    <th scope='col'>Question</th>
                                                                    <th scope="col">Option_a</th>
                                                                    <th scope="col">Option_b </th>
                                                                    <th scope="col">Option_c</th>
                                                                    <th scope="col">Option_d</th>
                                                                    <th scope='col'>Answer</th>
                                                                    <th scope='col'>Solution</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    questionListCompetitiveExam.length !== questionArrayIndexCompetitiveExam.length && questionListCompetitiveExam?.length > 0 ?
                                                                        questionListCompetitiveExam?.map((question, index) => {
                                                                            <QuestionFilter key={index} question={question}></QuestionFilter>

                                                                            return (
                                                                                !questionArrayIndexCompetitiveExam.includes(question.q_id) && (
                                                                                    <tr key={index}>
                                                                                        <td>
                                                                                            <input
                                                                                                type='checkbox'
                                                                                                disabled={examCreateDataCompetitiveExam.lesson_id === ""}
                                                                                                onChange={() => handleQuestionUpdateCompetitiveExam(question)}
                                                                                            />
                                                                                        </td>
                                                                                        <th scope="row" className='sl_no'>{index + 1}</th>
                                                                                        <td>{question.q_level}</td>
                                                                                        <td>{question.q_type}</td>
                                                                                        <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                                                                        <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                                                                        <td>{question.ans}</td>
                                                                                        <td>
                                                                                            <button
                                                                                                className="btn btn-primary view_icon mt-1"
                                                                                                type="button"
                                                                                                onClick={() => {
                                                                                                    setVisibleSolution(!visibleSolution);
                                                                                                    setModalData(question.sol);
                                                                                                }}
                                                                                            >
                                                                                                <i className="fa fa-eye"></i>
                                                                                            </button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            );
                                                                        })
                                                                        :
                                                                        (<tr>
                                                                            <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                        </tr>)
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default UploadExam;